import * as React from 'react';

import { ClientStatusEditorView } from "./clientstatus-editor.view";

interface ClientStatusEditorControllerProps {
    label?: string;
    mode: ControlMode;
    value: number | null;
    onChanged: (value: number | null) => void;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ClientStatusEditorController extends React.Component<ClientStatusEditorControllerProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            <ClientStatusEditorView {...this.props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/clientstatus-editor.controller.tsx